import React from 'react';
import { Form, Col, Row, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

class InvoicePaymentForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        console.log(props);
        this.state = {
            user: userExists ? props.location.state.user : {},
            invoices: [],
            totalAmount: 0,
            invoiceKeys: props.location.state.invoiceKeys,
            accountID: props.location.state.accountID,
            forceRefreshVar: 0,
            loading: true,
            embedURL: ''
        };
        this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
        this.hideSpinner = this.hideSpinner.bind(this);
        this.createTransaction = this.createTransaction.bind(this);
    }

    componentDidMount() {
        console.log(this.state.invoiceKeys);
        axios.get(`${Constants.apiURL}/api/Payment/invoicesByKey`, {
            params: {
                invoiceKeys: this.state.invoiceKeys.join(',')
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState({
                    invoices: JSON.parse(response.data.data),
                    totalAmount: response.data.totalAmount
                }, this.createTransaction);
            }
        }).catch((response) => {

        });
    }

    createTransaction() {

        let invoiceNumbers = this.state.invoices.map(function (invoice) {
            return invoice.DocumentNumber;
        }).join(",");

        for (let i = 0; i < this.state.invoices.length; i++) {
            if (this.state.invoices[i].InvoiceStatus != "Past due" && this.state.invoices[i].InvoiceStatus != "Outstanding") {
                alert("A pending payment has been found for one or more of these invoices.");
                return;
            }
        }

        axios.get(`${Constants.apiURL}/api/Payment/create`, {
            params: {
                accountID: this.state.accountID,
                invoiceNumber: invoiceNumbers,
                paymentAmount: this.state.totalAmount,
                type: 'Credit'
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState({
                    token: response.data.token,
                    key: response.data.key,
                    embedURL: response.data.url + '?key=' + response.data.key + '&token=' + response.data.token
                });
            }
        }).catch((response) => {
            alert(response.response.data);

        });
    }

    handlePaymentTypeChange(event) {
        this.setState({
            loading: true
        }, function () {
            axios.get(`${Constants.apiURL}/api/Payment/update`, {
                params: {
                    key: this.state.key,
                    type: event.target.value
                }
            }).then(response => {
                console.log(response);
                if (response.data) {
                    this.setState({
                        token: response.data.token,
                        key: response.data.key,
                        embedURL: response.data.url + '?key=' + response.data.key + '&token=' + response.data.token
                    });
                }
            }).catch((response) => {

            });
        });
    }

    hideSpinner() {
        this.setState({
            loading: false
        });
    }

    render() {
        const columns = [
            {
                dataField: 'DocumentNumber',
                text: 'Invoice #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'PONumber',
                text: 'PO #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DocumentDate',
                text: 'Invoice Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DueDate',
                text: 'Due Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OriginalAmount',
                text: 'Total Invoice Amount',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceDue',
                text: 'Invoice Balance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'InvoiceStatus',
                text: 'Status',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceDue',
                text: 'Payment Amount',
                align: 'right',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            }

        ];
        return (
            <div class="invoice_payment">
                <SiteMenu user={this.state.user} currentPage='invoicePayment' />
                <Form.Label style={{ padding: '15px 15px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 24 }}>Selected Invoices</Form.Label>

                <BootstrapTable
                    keyField="InvoiceKey"
                    wrapperClasses="table-responsive"
                    data={this.state.invoices}
                    columns={columns}
                />
                <Row style={{ justifyContent: 'right' }} >
                    <Col xs='auto' sm='auto' md='auto'>
                        <Form.Label style={{ padding: '15px 0px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 16 }}>
                            Payment Type:
                        </Form.Label>
                        </Col>
                        <Col xs='auto' sm='auto' md='auto'>
                        <Form.Select onChange={this.handlePaymentTypeChange} name="paymentType" size="sm" style={{ margin: '14px 0px 0px 0px', width: '180px', verticalAlign: 'middle' }}>
                                <option value="Credit">Credit Card</option>
                                <option value="eCheck">ACH / eCheck</option>
                        </Form.Select>
                    </Col>
                    <Col width='100%'/>
                    <Col xs='auto' sm='auto' md='auto'>
                        <Form.Label style={{ padding: '15px 0px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 18 }}>Total Selected Amount: </Form.Label>
                    </Col>
                    <Col xs='auto' sm='auto' md='auto'>
                        <Form.Label style={{ padding: '15px 15px 0px 5px', marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: 18 }}>${this.state.totalAmount}</Form.Label>
                    </Col>
                </Row>
                <Form.Label style={{ padding: '5px 0px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontStyle: 'italic', color: '#FF0000', fontSize: '14px', fontWeight: '500' }}>There is a 2.5% surcharge on all Credit Card payments.  There is no fee for Debit Card or EFT Payments.</Form.Label>

                <div style={{ backgroundColor:'#f7f7f7', width: '850px', height: '800px', display: 'flex', flexDirection: 'column', justifyContent:'center', alignContent:'center' }}>

                    {this.state.loading ? (<Spinner
                        style={{alignSelf:'center'}}
                        animation="border"
                        role="status"
                        aria-hidden="true"
                    />
                    ) : null}
                    <iframe class="payment_iframe" hidden={this.state.loading} onLoad={this.hideSpinner} style={{ width: '850px', height: '100%' }} src={this.state.embedURL} key={this.state.forceRefreshVar} />
                    </div>
            </div>
        );
    }
}

export default InvoicePaymentForm;